import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Error } from "./routes/error";
import Provider from "./context/Provider";
import Invite from "./routes/invite/Invite";
import Dashboard from "./routes/dashboard/Dashboard";
import Bond from "./routes/bond/Bond";
import LegalDisclaimer from "./routes/legalDisclaimer/LegalDisclaimer";
import IndicatorsIndexes from "./routes/indicatorsIndexes/IndicatorsIndexes";
import Bonds from "./routes/bonds/Bonds";
import Country from "./routes/country/Country";
import OmniChart from "./routes/omniChart/OmniChart";
import ProtectedRoute from "./routes/ProtectedRoute";

function App() {

    return (
        <BrowserRouter>
            <Provider>
                <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route
                        path="/invite"
                        element={<Invite />}
                    />
                    <Route element={<ProtectedRoute />}>
                        <Route path='/dashboard' element={<Dashboard />} />
                        <Route path='/bond/:id' element={<Bond />} />
                        <Route path='/omnichart/' element={<OmniChart />} />
                        <Route path='/bonds/' element={<Bonds />} />
                        <Route path='/country/:id' element={<Country />} />
                        <Route path='/indicators-indexes' element={<IndicatorsIndexes />} />
                        <Route path='/legal-disclaimer' element={<LegalDisclaimer />} />
                    </Route>
                    <Route path='*' element={<Error code={404} description="Oh no! The requested page does not exist." />} />
                </Routes>
            </Provider>
        </BrowserRouter>
    );
}
export default App;